import { createContext, useContext, useMemo, useState } from 'react';

const TourContext = createContext({
  request: null,
  startPageTour: () => {},
  clearRequest: () => {}
});

export const TourProvider = ({ children }) => {
  const [request, setRequest] = useState(null);

  const startPageTour = (pathname) => {
    setRequest({ pathname, id: Date.now() });
  };

  const clearRequest = () => {
    setRequest(null);
  };

  const value = useMemo(
    () => ({ request, startPageTour, clearRequest }),
    [request]
  );

  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
};

export const useTour = () => useContext(TourContext);
